import { useState } from "react";
import { List, ChevronDown } from "lucide-react";
import { musicianColor, musicianLabel } from "./mapUtils";

export function MapLegend({ items, id }) {
  return (
    <ul id={id} className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-zinc-300" aria-label="Legenda do mapa" data-testid="express-map-legend">
      {items.map((it) => (
        <li key={it.label} className="inline-flex items-center gap-1.5">
          <span aria-hidden="true" className="h-4 min-w-4 px-1 rounded-full text-[10px] font-extrabold text-zinc-950 flex items-center justify-center" style={{ background: it.hex }}>{it.glyph}</span>
          <span className="first-letter:uppercase">{it.label}</span>
        </li>
      ))}
    </ul>
  );
}

// Alternativa em texto ao mapa (WCAG 1.1.1): mesma informação acessível a leitores de tela e teclado.
export function MusicianList({ musicians = [], radiusKm, testid = "express-musician-list" }) {
  const [open, setOpen] = useState(false);
  const shown = musicians.filter((m) => m.distance_km != null || m.status);
  const listId = `${testid}-items`;
  return (
    <div className="rounded-2xl border border-white/10 bg-[#0D0D11]" data-testid={testid}>
      <button type="button" onClick={() => setOpen((v) => !v)} aria-expanded={open} aria-controls={listId} data-testid={`${testid}-toggle`}
        className="w-full min-h-[44px] px-4 flex items-center justify-between gap-2 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FF8A3D] rounded-2xl">
        <span className="inline-flex items-center gap-2"><List className="h-4 w-4 text-[#FF8A3D]" aria-hidden="true" />Ver músicos em lista ({shown.length})</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} aria-hidden="true" />
      </button>
      {open && (
        <ul id={listId} className="divide-y divide-white/5 px-4 pb-2 max-h-72 overflow-y-auto">
          {!shown.length && <li className="py-3 text-sm text-zinc-400">Nenhum músico encontrado ainda.</li>}
          {shown.map((m, i) => {
            const col = musicianColor(m);
            const out = !m.status && radiusKm != null && m.distance_km > radiusKm;
            return (
              <li key={`${m.id}-${i}`} className="py-2.5 flex items-center justify-between gap-3 text-sm" data-testid={`${testid}-item-${i}`}>
                <div className="min-w-0">
                  <div className="font-medium truncate">{m.stage_name || "Músico"}</div>
                  <div className="text-xs text-zinc-400">{m.instrument || m.instruments?.[0] || ""}{m.distance_km != null ? ` · cerca de ${Math.round(m.distance_km)} km` : ""}{out ? " · fora do raio atual" : ""}</div>
                </div>
                <span className="shrink-0 text-xs font-semibold px-2 py-1 rounded-full border" style={{ color: col.hex, borderColor: `${col.hex}66` }}>{musicianLabel(m)}</span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
